import { Modal } from 'antd'
import { FormState } from '@/state'
import { formStateActions } from '@/state/actions'

import './viewer.scss'

export default function SubsectionFileViewer() {
  const renderImage = () => {
    return (
      <img
        src={FormState.fileViewer.value.fileBase64String as string}
        alt='Visor de imagenes'
        style={{ width: '100%', maxHeight: '80vh', objectFit: 'contain' }}
      />
    )
  }

  const renderPDF = () => {
    return (
      <embed
        className='pdf-viewer'
        src={FormState.fileViewer.value.fileBase64String as string}
        type='application/pdf'
      />
    )
  }

  const renderModalContent = () => {
    if (FormState.fileViewer.value.isImage) return renderImage()
    if (FormState.fileViewer.value.isPdf) return renderPDF()

    return null
  }

  return (
    <Modal
      className='file-viewer'
      title='Visor de archivos'
      open={FormState.fileViewer.value.openModal}
      onCancel={formStateActions.closeFileViewer}
      footer={null}
      width='80%'
      style={{ padding: 0 }}
      maskClosable
      destroyOnClose
    >
      {renderModalContent()}
    </Modal>
  )
}
